import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

export const getMode = (value: boolean): InputMode => {
  return value ? 'error' : 'normal'
}